import { render, staticRenderFns } from "./uninjuryHistory.vue?vue&type=template&id=34ee8b9d"
import script from "./uninjuryHistory.vue?vue&type=script&lang=js"
export * from "./uninjuryHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ee8b9d')) {
      api.createRecord('34ee8b9d', component.options)
    } else {
      api.reload('34ee8b9d', component.options)
    }
    module.hot.accept("./uninjuryHistory.vue?vue&type=template&id=34ee8b9d", function () {
      api.rerender('34ee8b9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/noaccident/uninjuryHistory.vue"
export default component.exports